// Carga diferida: importadas de forma estática estas vistas del panel entraban al app.js que baja todo visitante (ver claude.md §14)
const Stats = () => import('@/views/dashboard/NewStats.vue')
const PersonalData = () => import('@/views/dashboard/PersonalData.vue')

export default [
  {
    path: 'estadisticas',
    name: 'stats',
    component: Stats,
    meta: { requireCompleteForm: true },
  },
  {
    path: 'datos-personales',
    name: 'personal-data',
    component: PersonalData,
    meta: { requireCompleteForm: true },
  },
  {
    path: 'cambiar-contraseña',
    name: 'change-password',
    component: () => import( /* webpackChunkName: "change-password" */ '@/views/dashboard/ChangePassword.vue'),
    meta: { requireCompleteForm: true },
  },
  {
    path: 'mis-empresas',
    name: 'my-business',
    component: () => import( /* webpackChunkName: "business" */ '@/views/dashboard/Business.vue'),
  },
  {
    path: 'empresas',
    name: 'business',
    component: () => import( /* webpackChunkName: "business" */ '@/views/dashboard/Business.vue'),
  },
  {
    path: 'crear-empresa',
    name: 'create-business',
    component: () => import( /* webpackChunkName: "create-business" */ '@/views/dashboard/CreateBusiness.vue'),
  },
  {
    path: 'editar-empresa/:companyId',
    name: 'edit-business',
    component: () => import( /* webpackChunkName: "edit-business" */ '@/views/dashboard/EditBusiness.vue'),
    props: true,
  },
  {
    path: 'solicitar/factoring',
    name: 'request-factoring',
    component: () => import(/* webpackChunkName: "factoring" */ '@/views/dashboard/Factoring.vue'),
  },
  {
    path: 'solicitar/credito',
    name: 'request-credit',
    component: () => import(/* webpackChunkName: "credit" */ '@/views/dashboard/Credit.vue'),
  },
  {
    path: 'contratos',
    name: 'contracts',
    component: () => import(/* webpackChunkName: "contracts" */ '@/views/dashboard/NewContracts.vue'),
    meta: { requireCompleteForm: true },
  },
  {
    path: 'mandatos',
    name: 'terms',
    component: () => import(/* webpackChunkName: "terms" */ '@/views/dashboard/Terms.vue'),
    meta: { requireCompleteForm: true },
  },
  {
    path: 'declaraciones',
    name: 'declaration',
    component: () => import(/* webpackChunkName: "terms" */ '@/views/dashboard/Declarations.vue'),
    meta: { requireCompleteForm: true },
  },
  {
    path: 'pagares-y-certificados',
    name: 'iou-and-certificates',
    component: () => import(/* webpackChunkName: "iou-and-certificates" */ '@/views/dashboard/IOUAndCertificates.vue'),
    meta: { requireCompleteForm: true },
  },
  {
    path: 'mi-perfil',
    name: 'profile-investment',
    component: () => import(/* webpackChunkName: "iou-and-certificates" */ '@/views/dashboard/EditProfileInvestment.vue'),
    props: true,
    meta: { requireCompleteForm: true },
  },
  {
    path: 'preguntas-perfil',
    name: 'profile-investment-question',
    component: () => import(/* webpackChunkName: "iou-and-certificates" */ '@/views/dashboard/ProfileInvestmentQuestions.vue'),
    props:true
  },
  {
    path: 'editar-perfil',
    name: 'editar-profile-investment-question',
    component: () => import(/* webpackChunkName: "iou-and-certificates" */ '@/views/dashboard/EditProfileInvestment.vue'),
    props:true
  },
]